// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-box-container {
  width: 100%;
  max-width: 1000px;
  align-self: center;
  margin-left: 65px;
  margin-right: 30px;
  display: flex;
  flex-direction: row;
  height: auto;
  padding: 0px 20px 10px 20px;
  z-index: 1000;
  box-sizing: border-box;
  justify-content: center;
}

.chat-box {
  display: flex;
  align-items: flex-end;
  background-color: #EAECEF;
  border-color: #BCC0C7;
  border-style: solid;
  border-width: 1px;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-left: 15px;
  border-radius: 12px;
  padding: 5px;
  min-width: 83%;
  max-width: 900px;
  max-height: 300px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.file-input-label {
  cursor: pointer;
  padding: 5px;
  border-radius: 20px;
  color: #5e17eb;
  margin-right: -5px;
  font-size: 23px;
  background-color: #E6E6FA;
  align-self: flex-end;
}

.file-input-label:hover {
  background-color: #5e17eb;
  color: #fff;
  transform: scale(1.05);
  transition: transform 0.2s ease-in-out;
}

.file-input {
  display: none;
}

.input-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.image-preview-container {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.image-preview {
  max-width: 100px;
  max-height: 120px;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  border-radius: 8px;
}

.remove-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 2px;
  border-radius: 50%;
}

.remove-icon:hover {
  color: #ff4d4d;
}

.chat-input {
  flex-grow: 1;
  color: #2C3E50;
  border: none;
  outline: none;
  background-color: transparent;
  resize: none;
  min-height: 35px;
  font-size: 16px;
  line-height: 1.5;
  overflow-y:scroll;
  scrollbar-width: none;
  width: auto;
  max-height: 200px;
  padding-left: 15px;
  padding-right: 10px;
}

.send-button {
  border-radius: 20px;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  font-size: 22px;
  width: 44px;
  height: 44px;
  align-self: flex-end;
  background-color: #5e17eb;
  color: white;
  transition: background-color 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
}

.send-button:hover {
  background-color: #4e13ba;
  transform: scale(1.05);
  transition: transform 0.2s ease-in-out;
}

.full-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.full-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
}

/* Dark Mode Styles */
.dark-mode .chat-box {
  background-color: #2c2c2c;
  border-color: #555555;
  color: #e0e0e0;
}

.dark-mode .chat-input {
  color: #e0e0e0;
}

.dark-mode .send-button {
  background-color: #3c3c3c;
  color: #e0e0e0;
}

.dark-mode .send-button:hover {
  background-color: #4a90e2;
}

.dark-mode .file-input-label {
  background-color: #333333;
  color: #e0e0e0;
}

.dark-mode .file-input-label:hover {
  background-color: #444444;
}

.dark-mode .remove-icon {
  color: #e0e0e0;
  background-color: rgba(255, 255, 255, 0.6);
}

.dark-mode .image-preview-container {
  border: 1px solid #444444;
}



@media (max-width: 720px) {
  .chat-input {
    min-height: 30px;
    font-size: 14px;
  }
}

@media ( max-width:480px) {
  .chat-box{
  min-width:70%;
  margin-left: 10px;
  }
  .new-button{
  margin-top:4px;
  background-color:#ffff;
  }
  .dark-mode .new-button{
   background-color:#333333;
  }
  .dark-mode .bi-plus-circle{
   color:#fff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatBox.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;EACA,aAAa;EACb,iBAAiB;EACjB;EACA;EACA,cAAc;EACd,sBAAsB;EACtB;EACA;GACC,wBAAwB;EACzB;EACA;GACC,UAAU;EACX;AACF","sourcesContent":[".chat-box-container {\n  width: 100%;\n  max-width: 1000px;\n  align-self: center;\n  margin-left: 65px;\n  margin-right: 30px;\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  padding: 0px 20px 10px 20px;\n  z-index: 1000;\n  box-sizing: border-box;\n  justify-content: center;\n}\n\n.chat-box {\n  display: flex;\n  align-items: flex-end;\n  background-color: #EAECEF;\n  border-color: #BCC0C7;\n  border-style: solid;\n  border-width: 1px;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  margin-left: 15px;\n  border-radius: 12px;\n  padding: 5px;\n  min-width: 83%;\n  max-width: 900px;\n  max-height: 300px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.file-input-label {\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 20px;\n  color: #5e17eb;\n  margin-right: -5px;\n  font-size: 23px;\n  background-color: #E6E6FA;\n  align-self: flex-end;\n}\n\n.file-input-label:hover {\n  background-color: #5e17eb;\n  color: #fff;\n  transform: scale(1.05);\n  transition: transform 0.2s ease-in-out;\n}\n\n.file-input {\n  display: none;\n}\n\n.input-container {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n}\n\n.image-preview-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.image-preview {\n  max-width: 100px;\n  max-height: 120px;\n  cursor: pointer;\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.image-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  border-radius: 8px;\n}\n\n.remove-icon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.6);\n  padding: 2px;\n  border-radius: 50%;\n}\n\n.remove-icon:hover {\n  color: #ff4d4d;\n}\n\n.chat-input {\n  flex-grow: 1;\n  color: #2C3E50;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  resize: none;\n  min-height: 35px;\n  font-size: 16px;\n  line-height: 1.5;\n  overflow-y:scroll;\n  scrollbar-width: none;\n  width: auto;\n  max-height: 200px;\n  padding-left: 15px;\n  padding-right: 10px;\n}\n\n.send-button {\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n  margin-left: 10px;\n  font-size: 22px;\n  width: 44px;\n  height: 44px;\n  align-self: flex-end;\n  background-color: #5e17eb;\n  color: white;\n  transition: background-color 0.3s ease;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);\n}\n\n.send-button:hover {\n  background-color: #4e13ba;\n  transform: scale(1.05);\n  transition: transform 0.2s ease-in-out;\n}\n\n.full-image-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n}\n\n.full-image {\n  max-width: 90%;\n  max-height: 90%;\n  border-radius: 8px;\n}\n\n/* Dark Mode Styles */\n.dark-mode .chat-box {\n  background-color: #2c2c2c;\n  border-color: #555555;\n  color: #e0e0e0;\n}\n\n.dark-mode .chat-input {\n  color: #e0e0e0;\n}\n\n.dark-mode .send-button {\n  background-color: #3c3c3c;\n  color: #e0e0e0;\n}\n\n.dark-mode .send-button:hover {\n  background-color: #4a90e2;\n}\n\n.dark-mode .file-input-label {\n  background-color: #333333;\n  color: #e0e0e0;\n}\n\n.dark-mode .file-input-label:hover {\n  background-color: #444444;\n}\n\n.dark-mode .remove-icon {\n  color: #e0e0e0;\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.dark-mode .image-preview-container {\n  border: 1px solid #444444;\n}\n\n\n\n@media (max-width: 720px) {\n  .chat-input {\n    min-height: 30px;\n    font-size: 14px;\n  }\n}\n\n@media ( max-width:480px) {\n  .chat-box{\n  min-width:70%;\n  margin-left: 10px;\n  }\n  .new-button{\n  margin-top:4px;\n  background-color:#ffff;\n  }\n  .dark-mode .new-button{\n   background-color:#333333;\n  }\n  .dark-mode .bi-plus-circle{\n   color:#fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
